import { COOKIE_KEYS, sessionStorageKeys } from 'constants/common'
import Cookies from 'js-cookie'
import { formatPhoneNumber, getBirthDate } from 'utils/common'
import _capitalize from 'lodash/capitalize'
import { dateFormats } from 'constants/common'
import { format } from 'date-fns'
import {
  ClientEmergencyContactDataObject,
  ClientPersonalData,
  ClientResponsiblePartyData,
} from 'types/thrivecare/client-face'
import { thriveCareV1PageRoutes } from 'constants/routing'

export const clearSessionStorageClinicianData = (): void =>
  sessionStorage.removeItem(sessionStorageKeys.THRIVECARE_CLINICIAN_DATA)

export const clearSupeAdminCookies = (): void =>
  Cookies.remove(COOKIE_KEYS.SUPERADMIN_DATA)

type FormattedClientPersonalInfo = {
  formattedPhoneNumber: string
  dob: string
  gender: string
}

export const getFormattedClientPersonalInfo = (
  client: ClientPersonalData
): FormattedClientPersonalInfo => {
  const { cellPhone, homePhone, officePhone, otherPhone, dateOfBirth, gender } =
    client || {}

  const phone = cellPhone || homePhone || officePhone || otherPhone
  const formattedPhoneNumber = formatPhoneNumber(phone)

  const dob = dateOfBirth
    ? format(getBirthDate(dateOfBirth), dateFormats.MONTH_DAY_YEAR_DOB_FORMAT)
    : ''

  return {
    formattedPhoneNumber,
    dob,
    gender: _capitalize(gender),
  }
}

export const getFormattedResponsiblePartyInfo = (
  responsibleParty: ClientResponsiblePartyData
): { formattedPhoneNumber: string } => {
  const { cellPhone, homePhone, officePhone, otherPhone } =
    responsibleParty || {}

  const phone = cellPhone || homePhone || officePhone || otherPhone
  const formattedPhoneNumber = formatPhoneNumber(phone)

  return {
    formattedPhoneNumber,
  }
}

type FormattedEmergencyContact = {
  formattedPhoneNumber: string
  emergencyContact: string
}

export const getFormattedEmergencyContactInfo = (
  emergencyContactInfo: ClientEmergencyContactDataObject
): FormattedEmergencyContact => {
  const {
    cellPhone,
    homePhone,
    workAltPhone,
    emergencyContact,
  } = emergencyContactInfo

  const formattedPhoneNumber = formatPhoneNumber(
    cellPhone || homePhone || workAltPhone
  )

  return {
    formattedPhoneNumber,
    emergencyContact,
  }
}

export const thrivecareDailyAgendaRedirect = (
  redirectUrl: string,
  isCalendarDailyAgendaEnabled: boolean
): string => {
  const redirectPath = redirectUrl.split(/[?#]/)[0]

  if (
    isCalendarDailyAgendaEnabled &&
    (redirectPath === thriveCareV1PageRoutes.THRIVECARE_V1_MY_SCHEDULE ||
      redirectPath === `${thriveCareV1PageRoutes.THRIVECARE_V1_MY_SCHEDULE}/`)
  ) {
    redirectUrl = redirectUrl.replace(
      thriveCareV1PageRoutes.THRIVECARE_V1_MY_SCHEDULE,
      thriveCareV1PageRoutes.THRIVECARE_CALENDAR
    )
  }

  return redirectUrl
}
